export const SITE_URL = 'https://bmgas.no';

export const PUBLIC_ROUTES = [
  '/',
  '/bestill',
  '/priser',
  '/tilbud',
  '/tjenester',
  '/tjenester/privat',
  '/tjenester/bedrift-borettslag',
  '/tjenester/rehab-riving',
  '/tjenester/storsekker',
  '/fraksjoner',
  '/utstyr',
  '/om-oss',
  '/kunder',
  '/miljo',
  '/nyheter',
  '/kontakt',
  '/vilkar',
  '/personvern',
] as const;

export function canonicalUrl(pathname: string): string {
  const path = (PUBLIC_ROUTES as readonly string[]).includes(pathname) ? pathname : '/';
  return path === '/' ? `${SITE_URL}/` : `${SITE_URL}${path}`;
}
